import { useFormikContext } from "formik";
import { ProtocolResponse } from "../../models/dtos";
import CustomInputText from "../../components/forms/CustomInputText";
import CustomDropdown from "../../components/forms/CustomDropdown";
import CustomDatepicker from "../../components/forms/CustomDatepicker";
import ItemBrowser from "../../components/forms/ItemBrowser";

interface ProtocolMainFieldsProps {
  teachers: any[];
  substituteTeachers: any[];
  specialities: any[];
  sessionTypes: any[];
  examTypes: any[];
  academicYears: any[];
  semesterTypes: any[];
  useSubjectsByFaculty: boolean;
  setUseSubjectsByFaculty: (value: boolean) => void;
  loadSubjects: (specialityId: number) => any;
  subjectLabel?: string;
}

const ProtocolMainFields = ({
  teachers,
  substituteTeachers,
  specialities,
  sessionTypes,
  examTypes,
  academicYears,
  semesterTypes,
  useSubjectsByFaculty,
  setUseSubjectsByFaculty,
  loadSubjects,
  subjectLabel,
}: ProtocolMainFieldsProps) => {
  const formik = useFormikContext<Partial<ProtocolResponse>>();

  return (
    <div className="grid">
      <div className="col-12 md:col-4">
        <CustomInputText id="protocolNumber" label="Номер на протокол" />
      </div>

      <div className="col-12 md:col-4">
        <div className="flex flex-row align-items-center gap-2">
          <div className="flex-1">
            <CustomDropdown
              key={`teacher-${teachers.length}`}
              id="teacherId"
              label="Преподавател"
              options={teachers}
              optionLabel={(option: any) =>
                `${option.firstName} ${option.middleName} ${option.lastName} - ${
                  option.academicPositionShortName || ""
                } ${option.academicRankShortName || ""} - ${option.departmentFacultyShortName || ""}`
              }
              optionValue="teacherId"
              filter
              filterMatchMode="startsWith"
            />
          </div>
        </div>
      </div>

      <div className="col-12 md:col-4">
        <div className="flex flex-row align-items-center gap-2">
          <div className="flex-1">
            <CustomDropdown
              key={`substitute-${substituteTeachers.length}`}
              id="substituteTeacherId"
              label="Преподавател (подписващ)"
              options={substituteTeachers}
              optionLabel={(option: any) =>
                `${option.firstName} ${option.middleName} ${option.lastName} - ${
                  option.academicPositionShortName || ""
                } ${option.academicRankShortName || ""} - ${option.departmentFacultyShortName || ""}`
              }
              optionValue="teacherId"
              filter
            />
          </div>
        </div>
      </div>

      <div className="col-12 md:col-4">
        <CustomDropdown
          key={`speciality-${specialities.length}`}
          id="specialityId"
          label="Специалност"
          options={specialities}
          optionLabel={(option: any) =>
            option.latestActivePlanCode ? `${option.name} (план: ${option.latestActivePlanCode})` : option.name
          }
          optionValue="specialityId"
          filter
        />
      </div>

      <div className="col-12 md:col-4 flex flex-row gap-2">
        <div className="flex-1">
          <ItemBrowser
            id="subjectId"
            label="Дисциплина"
            optionsPromise={() => loadSubjects(formik.values.specialityId || 0)}
            idField="subjectId"
            labelField="nameWithPlanCodes"
            currentLabelText={subjectLabel}
            columns={[
              { field: "subjectId", header: "ID", sortable: true, filter: true },
              { field: "nameWithPlanCodes", header: "Име", sortable: true, filter: true },
            ]}
          />
        </div>
        <div className="flex align-items-center">
          <input
            type="checkbox"
            id="useSubjectsByFaculty"
            checked={useSubjectsByFaculty}
            onChange={(e) => setUseSubjectsByFaculty(e.target.checked)}
          />
        </div>
      </div>

      <div className="col-12 md:col-4">
        <CustomDatepicker id="issueDate" label="Дата на издаване" />
      </div>
      <div className="col-12 md:col-4">
        <CustomDropdown
          key={`session-${sessionTypes.length}`}
          id="sessionTypeId"
          label="Сесия"
          options={sessionTypes}
          optionLabel="name"
          optionValue="sessionTypeId"
        />
      </div>
      <div className="col-12 md:col-4">
        <CustomDropdown
          key={`exam-${examTypes.length}`}
          id="examTypeId"
          label="Тип изпит"
          options={examTypes}
          optionLabel="name"
          optionValue="examTypeId"
          required
        />
      </div>
      <div className="col-12 md:col-3">
        <CustomDatepicker id="examDate" label="Дата на изпит" />
      </div>
      <div className="col-12 md:col-3">
        <CustomDatepicker id="secondExamDate" label="Втора/крайна дата" />
      </div>
      <div className="col-12 md:col-3">
        <CustomDropdown
          key={`year-${academicYears.length}`}
          id="academicYearId"
          label="Академична година"
          options={academicYears}
          optionLabel="name"
          optionValue="academicYearId"
        />
      </div>
      <div className="col-12 md:col-3">
        <CustomDropdown
          key={`semesterType-${semesterTypes.length}`}
          id="semesterTypeId"
          label="Семестър"
          options={semesterTypes}
          optionLabel="name"
          optionValue="semesterTypeId"
          required
        />
      </div>
      <div className="col-12 md:col-2">
        <CustomInputText id="semester" label="Номер семестър" type="number" />
      </div>
    </div>
  );
};

export default ProtocolMainFields;
